import { 
  FilterArtModel, 
  FilterFormModel,
  FilterOverflowModel,
  FilterBackwallModel,
} from './filter-form.model';

import { 
  BaseClass,
  dropProps,
} from '../';

import { 
  InputClass,
  InputModel, 
} from '../Form';

import { filterFormData, filterArtData, filterOverflowData, filterBackwallData } from './filter-form.data';

export class FilterArtClass extends BaseClass<FilterArtModel> implements FilterArtModel {
  get exos(): InputModel {
    return dropProps(this.props.exos, new InputClass(this.props.exos)); 
  }
  get varius(): InputModel {
    return dropProps(this.props.varius, new InputClass(this.props.varius)); 
  }
  get variusMed(): InputModel {
    return dropProps(this.props.variusMed, new InputClass(this.props.variusMed)); 
  }
  get medcare(): InputModel {
    return dropProps(this.props.medcare, new InputClass(this.props.medcare)); 
  }
}
export const filterArtValues = () => filterArtData && dropProps(filterArtData(), new FilterArtClass(filterArtData()));


export class FilterFormClass extends BaseClass<FilterFormModel> implements FilterFormModel {
  get oval(): InputModel {
    return dropProps(this.props.oval, new InputClass(this.props.oval)); 
  }
  get round(): InputModel {
    return dropProps(this.props.round, new InputClass(this.props.round)); 
  }
  get square(): InputModel {
    return dropProps(this.props.square, new InputClass(this.props.square)); 
  }
}
export const filterFormValues = () => filterFormData && dropProps(filterFormData(), new FilterFormClass(filterFormData()));


export class FilterOverflowClass extends BaseClass<FilterOverflowModel> implements FilterOverflowModel {
  get overflowWith(): InputModel {
    return dropProps(this.props.overflowWith, new InputClass(this.props.overflowWith)); 
  }
  get overflowWithout(): InputModel {
    return dropProps(this.props.overflowWithout, new InputClass(this.props.overflowWithout)); 
  }
}
export const filterOverflowValues = () => filterOverflowData && dropProps(filterOverflowData(), new FilterOverflowClass(filterOverflowData()));


export class FilterBackwallClass extends BaseClass<FilterBackwallModel> implements FilterBackwallModel {
  get preparedBackWallWith(): InputModel {
    return dropProps(this.props.preparedBackWallWith, new InputClass(this.props.preparedBackWallWith)); 
  }
  get preparedBackWallWithout(): InputModel {
    return dropProps(this.props.preparedBackWallWithout, new InputClass(this.props.preparedBackWallWithout)); 
  }
}
export const filterBackwallValues = () => filterBackwallData && dropProps(filterBackwallData(), new FilterBackwallClass(filterBackwallData()));